goog.provide('yext.plugins.selectify');

/**
 * Selectify jQuery plugin
 * Calling this plugin on a selector that contains a single unordered list
 * will style that list to look like a <select> dropdown. Additionally, creates
 * a <select> that is appended to the end of the selected element.
 *
 * This should be used in place of selectbox when a multiline dropdown is needed
 *
 * Usage:
 * $('selector').selectify(options); - to initialize and create the selectify
 * $('selector').selectify('method', args ...) - to call the API function 'method' with the arguments 'args'
 *
 * You can designate one of the li elements as a placeholder by setting the data-placeholder attribute to true.
 * The contents of that li will then be used as a placeholder
 *
 * You can also designate one of the li elements to be a non clickable option that will be shown when there are no
 * options in the dropdown. This can be done by setting the data-empty-option-message attribute to true.
 *
 * NOTE: The data attributes above need to be explicitly set in the markup.
 *
 * @author Vincent Le (vple@yext.com)
 * @author Aneesh Butani (abutani@yext.com)
 */

(function($) {
  // Map that keeps track of the selectify instances created
  var selectifyInstances = {};

  // Used to assign unique ids to each dropdown behind the selectify objects
  var selectifyId = 0;

  /**
   * @constructor
   * @param {string} element - A css selector to selectify. The corresponding
   *   element should contain a <ul> element.
   * @param {!Object} options - Optional settings to define things such as
   *  - width: Width of the select box
   *  - optionsWidth: Width of the select options
   *  - selectedHeight: height of the selectbox
   *  - singleLineSelectValue: true/false, indicates if the options are multi-line or single line
   */
  var Selectify = function(element, options) {
    this.$el = $(element);
    this.$ul = this.$el.find('ul');
    this.init(options);
    this.createSelect();
    this.style();
    this.selectDefault();
    this.bindEvents();
    this.$el.show();
    element.attr('selectify-id', selectifyId);
    selectifyInstances[selectifyId] = this;
    selectifyId++;
  };

  /**
   * Default configurable options.
   */
  Selectify.prototype.defaults = {
    singleLineSelectValue: true,
    disabled: false,
  };

  /**
   * Initialization
   */
  Selectify.prototype.init = function(options) {
    options = options || {};
    options.optionsWidth = options.optionsWidth || options.width;
    this.options = $.extend(true, {}, this.defaults, options);
  };

  /**
   * Creates the select dropdown and inserts it into the DOM at the end of
   * the element that selectify was called on.
   */
  Selectify.prototype.createSelect = function() {
    this.deleteSelect();
    var options = '';
    var name = '';
    if (this.$ul.attr('data-name')) {
      name = 'name="' + this.$ul.attr('data-name') + '" ';
    }
    this.$select = $('<select ' + name + 'class="no-selectbox"></select>').hide();
    var that = this;

    this.$ul.children('li').each(function(index) {
      var $this = $(this);
      var classes = $this.attr('class');
      var selected = $this.attr('selected') !== undefined;
      var val = $this.attr('data-value');

      var $option = $('<option></option>').addClass(classes).val(val);

      if (selected) {
        $option.attr('selected', 'selected');
      }

      if ($this.data('placeholder')) {
        that.placeholder = $this;
      } else if ($this.data('empty-option-message')) {
        that.emptyOptionsMessage = $this;
      } else {
        $option.appendTo(that.$select);
      }
    });

    this.$el.append(this.$select);
  };

  /**
   * Clean up the older hidden select element
   */
  Selectify.prototype.deleteSelect = function() {
    if (this.$select) {
      this.$select.remove();
    }
  };

  /**
   * Returns the number of 'real' options available in the selectify
   * for example the placeholder option, and the empty message option
   * are excluded from the count
   *
   * @return {number} number of options in the dropdown
   */
  Selectify.prototype.numberOfOptions = function() {
    return (this.$ul.find('li').length - this.$ul.find('li[data-placeholder="true"],li[data-empty-option-message="true"]').length);
  };

  /**
   * Adds styling (by adding classes) to make the original list look like a
   * dropdown.
   */
  Selectify.prototype.style = function() {
    this.$el.addClass('selectify-root');
    this.$ul.addClass('selectify-options');

    this.$ul.children('li').each(function() {
      $(this).addClass('selectify-option');
    });

    this.$selected = $(
      '<div class="selectify-selected">' +
      '<div class="selectify-html"></div>' +
      '<div class="selectify-arrow"></div>' +
      '</div>')
      .prependTo(this.$el);

    this.$selectedHtml = this.$selected.find('.selectify-html');

    if (this.options.optionsWidth) {
      this.$ul.css('width', this.options.optionsWidth);
    }

    this.$selected.find('.selectify-arrow').toggle(!this.options.disabled);
  };

  /**
   * Selects an element in the list and displays it as the selected option.
   * Also updates the corresponding <select> element.
   *
   * @param {!jQuery} $li - The list item to select.
   */
  Selectify.prototype.select = function($li) {
    var html = $li.html();

    if (this.options.singleLineSelectValue) {
      html = html.replace(/<br>/g, '');
    }

    this.$selectedHtml.html(html);
    this.$select.val($li.attr('data-value'));
    this.$select.change();
  };

  /**
   * Selects the default selected list item (<li selected>). Defaults to the
   * first list item if there is no designated default.
   */
  Selectify.prototype.selectDefault = function() {
    var $li = this.$ul.find('li[selected]').first();
    if ($li.length === 0) {
      $li = this.$ul.find('li').first();
    }

    if (this.numberOfOptions() > 0) {
      this.$ul.find('li[data-empty-option-message="true"]').remove();
    }
    this.$ul.find('li[data-placeholder="true"]').remove();
    this.createSelect();
    this.select($li);
  };

  /**
   * Binds handlers so the user can interact with the dropdown.
   */
  Selectify.prototype.bindEvents = function() {
    if (this.options.disabled) {
      return;
    }
    var that = this;

    this.$selected.click(function(e) {
      that.toggleActive(!that.active);
      e.stopPropagation();
    });

    this.$ul.on('click.selectify', 'li', function(e) {
      var $self = $(this);
      if (!$self.data('empty-option-message')) {
        that.select($self);
        that.toggleActive(!that.active);
      }
      e.stopPropagation();
    });

    $('html,body').not('selectify-root').on('click', function() {
      that.toggleActive(false);
    });
  };

  /**
   * Toggles whether or not to show the dropdown options.
   */
  Selectify.prototype.toggleActive = function(active) {
    this.active = active;
    this.$selected.toggleClass('selectify-active', active);
    this.$ul.toggleClass('selectify-active', active);
    this.$ul.position({
      'my': 'left top',
      'at': 'left bottom',
      'of': this.$el,
      'collision': 'flip',
      'offset': '0 3',
    });
  };

  $.fn.selectify = function(method) {
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method) {
      return methods['init'].apply(this, arguments);
    } else {
      $.error('Method ' + method + ' does not exist in Selectify!');
    }
  };

  // jQuery selectify API methods
  var methods = {
    /**
     * Initialize the selectify and create the select div + styling
     */
    'init': function(options) {
      this.each(function() {
        new Selectify($(this), options);
      });
    },

    /**
     * Returns the list item that is currently selected
     */
    'getSelected': function() {
      return this.find('.selectify-selected .selectify-html').children();
    },

    /**
     * Removes the option that the given index
     * @param {number} index
     */
    'removeOptionByIndex': function(index) {
      var selectify = selectifyInstances[this.attr('selectify-id')];
      var $optionToDelete = this.find('ul li').eq(index);
      $optionToDelete.remove();

      // If no options are in the drop down after deletion re-insert the empty row
      if (selectify.numberOfOptions() == 0) {
        selectify.$ul.prepend(selectify.emptyOptionsMessage);
      }

      // After deletion we reset the state of the dropbox. Add the placeholder back if one was specified
      if (selectify.placeholder) {
        selectify.$ul.prepend(selectify.placeholder);
      }

      selectify.selectDefault();
      selectify.createSelect();
    },

    /**
     * Resets the select by adding the placeholder back (if provided) and selecting default
     */
    'resetSelect': function() {
      // If the Selectify had a placeholder add it back to the ul
      var selectify = selectifyInstances[this.attr('selectify-id')];
      if (selectify) {
        if (selectify.placeholder) {
          selectify.$ul.prepend(selectify.placeholder);
        }
        selectify.selectDefault();
      }
    },

    /**
     * Add the given $li to the list of options contained in the selectify
     * @param {!jQuery} $li
     */
    'addOption': function($li) {
      var selectify = selectifyInstances[this.attr('selectify-id')];
      selectify.$ul.append($li);
      selectify.$ul.find('li[data-empty-option-message="true"]').remove();
      selectify.createSelect();
      selectify.select($li);
    },

    /**
     * Minimize/Maximize the dropdown
     * @param {boolean} flag  Minimize/Maximize the dropdown on false/true value
     */
    'toggleDisplay': function(flag) {
      var selectify = selectifyInstances[this.attr('selectify-id')];
      selectify.toggleActive(flag);
    },


    /**
     * Selects the given $li element
     * @param {!jQuery} $li
     */
    'updateAndSelectOption': function($li) {
      var selectify = selectifyInstances[this.attr('selectify-id')];
      $.proxy(selectify.select($li), selectify);
      selectify.createSelect();
    },
  };
})(jQuery);
